/** Visibilidad por app en `userSongs/{uid}/songs` (almacén compartido, listas separadas). */

export type UserSongAppId = 'play' | 'bordona';

export interface UserSongAppFields {
  /** Visible en Play (metalófono / flauta). */
  inPlay?: boolean;
  /** Visible en Bordona (guitarra, rasgueos, etc.). */
  inBordona?: boolean;
  /** App donde se creó el archivo originalmente. */
  createdInApp?: UserSongAppId;
}

export function songVisibleInPlay(data: UserSongAppFields): boolean {
  return data.inPlay === true;
}

/**
 * Canciones antiguas sin flags siguen en Bordona solamente.
 * Las subidas desde Play no aparecen en Bordona hasta importarlas.
 */
export function songVisibleInBordona(data: UserSongAppFields): boolean {
  if (data.inBordona === false) return false;
  if (data.inBordona === true) return true;
  if (data.inPlay === true) return false;
  if (data.createdInApp === 'play') return false;
  return true;
}

export function songImportableToPlay(data: UserSongAppFields & { musicXml?: string }): boolean {
  return !songVisibleInPlay(data) && typeof data.musicXml === 'string' && data.musicXml.length > 0;
}

export function songImportableToBordona(data: UserSongAppFields & { musicXml?: string }): boolean {
  return !songVisibleInBordona(data) && typeof data.musicXml === 'string' && data.musicXml.length > 0;
}

export function flagsForNewUpload(app: UserSongAppId): UserSongAppFields {
  if (app === 'play') {
    return { inPlay: true, inBordona: false, createdInApp: 'play' };
  }
  return { inPlay: false, inBordona: true, createdInApp: 'bordona' };
}

export function flagsImportToPlay(): Partial<UserSongAppFields> {
  return { inPlay: true };
}

export function flagsImportToBordona(): Partial<UserSongAppFields> {
  return { inBordona: true };
}

export function flagsRemoveFromPlay(): Partial<UserSongAppFields> {
  return { inPlay: false };
}

export function flagsRemoveFromBordona(): Partial<UserSongAppFields> {
  return { inBordona: false };
}
